import { useState } from 'react'
import { AccountRecord, useSetAccountToggleMutation } from '../../api/client'
import DescriptiveToggle from './DescriptiveToggle'

type Props = {
    account: AccountRecord
}

/**
 * Toggle for enabling/disabling screenshot capture for an account.
 *
 * When enabled, Arwen will automatically capture screenshots of content
 * from this account for moderation purposes.
 */
const EnableScreenshotsToggle = ({ account }: Props) => {
    const [setAccountToggleMutation, { loading }] = useSetAccountToggleMutation()
    const [enabled, setEnabled] = useState(account.toggles?.enableScreenshots ?? false)

    const onToggle = async (isEnabled: boolean) => {
        setEnabled(isEnabled)
        await setAccountToggleMutation({
            variables: {
                accountId: Number(account.id),
                toggleName: 'enable_screenshots',
                value: isEnabled
            }
        })
    }

    return (
        <DescriptiveToggle
            id="EnableScreenshots"
            checked={enabled}
            onToggle={onToggle}
            label="Enable Screenshots"
            loading={loading}
            subtitle="Capture visual snapshots of content for enhanced moderation and record-keeping."
            tooltip="Automatically capture screenshots of content for this account."
            disabled={false}
        />
    )
}

export default EnableScreenshotsToggle
